import * as React from "react";
import {Grid2 as Grid} from "@mui/material";
import StringInputField from "@/lib/components/inputfields/string-input-field";
import {CardEx} from "@/lib/components/CardEx";
import {useTranslation} from "react-i18next";
import {RequestKeyWordsI18N} from "@/translations";
import {DeclineReason} from "@/api/data-contracts";
import {DECLINE_REASON_LABEL_KEYS} from "@/common/request-cards/decline-reason-logic";

export type FeedbackReasonCardProps = {
    feedbackReason?: DeclineReason | null;
    feedbackFreeText?: string | null;
};

export const FeedbackReasonCard = ({ feedbackReason, feedbackFreeText }: FeedbackReasonCardProps) => {
    const { t } = useTranslation();

    // Only render when a reason has been provided
    if (!feedbackReason) {
        return null;
    }

    const hasFreeText = Boolean(feedbackFreeText?.trim());

    return (
        <CardEx title={t(RequestKeyWordsI18N.feedbackReasonCardTitle)}>
            <Grid container spacing={2}>
                <Grid size={{ sm: 12 }}>
                    <StringInputField
                        label={t(RequestKeyWordsI18N.feedbackReasonLabel)}
                        value={t(DECLINE_REASON_LABEL_KEYS[feedbackReason])}
                        disabled
                    />
                </Grid>
                {hasFreeText && (
                    <Grid size={{ sm: 12 }}>
                        <StringInputField
                            label={t(RequestKeyWordsI18N.feedbackFreeTextLabel)}
                            value={feedbackFreeText?.trim()}
                            multiline
                            minRows={3}
                            disabled
                        />
                    </Grid>
                )}
            </Grid>
        </CardEx>
    );
};
